import {
  Action, Module, Mutation, VuexModule,
} from 'vuex-module-decorators';
import SupportedLocale from '@/types/SupportedLocale';
import LocalizationState from '@/store/states/Localization';
import { GeneralAction, LocalizationAction } from '@/store/actions';
import { LocalizationGetter } from '@/store/getters';
import InitDataExtended from '@/models/InitDataExtended';

enum Mutators {
  HandleChangeLocale = 'localization.handleChangeLocale',
}

@Module
export default class LocalizationModule extends VuexModule<LocalizationState> {
  public locale: SupportedLocale = SupportedLocale.DE_DE;

  get [LocalizationGetter.Locale](): SupportedLocale {
    return this.locale;
  }

  @Mutation
  private [Mutators.HandleChangeLocale](payload: { locale: SupportedLocale }) {
    this.locale = payload.locale;
  }

  @Action
  private [GeneralAction.Init](payload: InitDataExtended) {
    this.context.commit(Mutators.HandleChangeLocale, { locale: payload.locale });
  }

  @Action
  private [LocalizationAction.ChangeLocale](payload: { locale: SupportedLocale }) {
    this.context.commit(Mutators.HandleChangeLocale, payload);
  }
}
